import './resourceSearchSummary.scss'
import templateUrl from './resourceSearchSummary.html'

/**
 * Resource Search Summary component.
 *
 * @example
 * <tmr-resource-search-summary></tmr-resource-search-summary>
 *
 * @type {ngComponent}
 */
export const tmrResourceSearchSummary = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrResourceSearchSummaryController',
}

/**
 * Controller of component {@link tmrResourceSearchSummary}.
 *
 * @type {ngController}
 */
export class tmrResourceSearchSummaryController {
  static ngType = 'controller'

  constructor($state, $stateParams, TmrSearchFormFilters) {
    'ngInject'
    Object.assign(this, { $state, $stateParams, TmrSearchFormFilters })
  }

  $onInit() {
    this.formatted = this.TmrSearchFormFilters.formatted
    this.hasFilters = Object.keys(this.formatted).length
  }

  /**
   * Removes a facet from the url and reloads the page.
   */
  remove(param, idx) {
    let val = this.$stateParams[param]
    if (Array.isArray(val)) val.splice(idx, 1)
    else val = null
    this.$state.go('.', { [param]: val }, { reload: true })
  }
}
